import React, { FC } from 'react';
import { useIntl } from 'react-intl';
import { useLocation } from 'react-router-dom';
import cx from 'classnames';

import { useServerData } from '@xingternal/hops';

import BaseContentSwitcher, {
  BaseContentSwitcherDataProps,
} from '@/components/BaseContentSwitcher';
import BaseButton from '@/components/BaseButton';
import { EXTERNAL_LINKS } from '@/routes';
import { useStickyLinkbar } from '@/hooks/useStickyLinkbar';
import { trackingParams } from '@/utils/tracking';

import styles from './LinkBar.css';

const resolveStylesLinkbar = (
  stickBarFixed: boolean,
  isWebview: boolean,
): string => {
  if (stickBarFixed) {
    return cx(styles.sticky, { [styles.stickyWebview]: isWebview });
  }

  return styles.inner;
};

export interface LinkBarNavigationProps extends BaseContentSwitcherDataProps {
  hidden?: boolean;
}

export type LinkBarProps = {
  navigation?: Array<LinkBarNavigationProps>;
};
const LinkBar: FC<LinkBarProps> = ({ navigation = [] }) => {
  const { formatMessage } = useIntl();
  const { pathname } = useLocation();
  const { isWebview, mobileProtocol } = useServerData();
  const { ref, stickBarFixed } = useStickyLinkbar();

  const notHiddenNavigation = navigation.filter(({ hidden }) => !hidden);

  const activeIndex = notHiddenNavigation.findIndex(
    ({ to }) => pathname === to,
  );

  const idealEmployerLink = isWebview
    ? `${mobileProtocol}${EXTERNAL_LINKS.preferences.mobileNative}`
    : EXTERNAL_LINKS.preferences.web;
  return (
    <div ref={ref} className={styles.container}>
      <div className={resolveStylesLinkbar(stickBarFixed, isWebview)}>
        <BaseContentSwitcher
          className={styles.contentSwitcher}
          activeItemIndex={activeIndex}
          data={notHiddenNavigation}
          size="small"
          variant="filled"
        />
        <div className={styles.projobsButtonWrapper}>
          <BaseButton
            size="small"
            variant="secondary"
            className={styles.projobsButton}
            href={idealEmployerLink}
            target="_self"
            trackingAttributes={trackingParams.projobs}
          >
            {formatMessage({ id: 'CP_IDEAL_EMPLOYER_LIST' })}
          </BaseButton>
        </div>
      </div>
    </div>
  );
};

export default LinkBar;
